import { HTMLAttributes, memo, PropsWithChildren } from 'react';
import cls from 'classnames';

import styles from './MenuList.module.css';

export interface MenuListProps extends HTMLAttributes<HTMLDivElement> {
  withRoundedCorners?: boolean;
  className?: string;
  light?: boolean;
}

function MenuList(props: PropsWithChildren<MenuListProps>) {
  const { withRoundedCorners, className, light, children, ...rest } = props;

  return (
    <div
      className={cls(
        styles.menuList,
        { [styles.menuListWithRoundedCorners]: withRoundedCorners, [styles.menuListLight]: light },
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}

export default memo(MenuList);
